var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBodyTypeUtilitarios(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 20,
    viewBox: "0 0 40 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#body-type-utilitarios_svg__clip0_5_285)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.55 13.55L2.7 13.1c-.1 0-.2-.1-.2-.25v-3.1c0-.1.05-.15.1-.2l.35-.2c0-.5.15-2.05 2.1-2.75 1.9-.65 3.3-1.2 3.6-1.3.6-.7 4.5-4.9 6.15-5.1C16.5.05 27-.15 34.7.2h.05c.05 0 1.4.55 1.65 2.5.2 1.7.3 6.8.3 7.65l.35.35c.05.05.1.1.1.2v1.6c0 .05 0 .1-.05.15l-.7.8c-.05.05-.1.1-.2.1h-2.6c-.15 0-.25-.1-.25-.25s.1-.25.25-.25h2.45l.55-.65V11l-.35-.35c-.05-.05-.1-.1-.1-.2 0-.05-.05-5.9-.3-7.7-.2-1.5-1.1-2-1.3-2.1-7.6-.3-18-.15-19.65.05-1.3.15-4.65 3.65-5.85 4.95-.05.05-.05.05-.1.05 0 0-1.5.6-3.7 1.3-1.95.65-1.8 2.35-1.8 2.35 0 .1-.05.2-.1.25L3 9.9v2.75l2.6.4c.15 0 .25.15.2.3 0 .1-.1.2-.25.2z",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.05 13.55h-14.8c-.15 0-.25-.1-.25-.25s.1-.25.25-.25h14.8c.15 0 .25.1.25.25s-.1.25-.25.25z",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.65 16.05c-1.5 0-2.75-1.25-2.75-2.75s1.25-2.75 2.75-2.75 2.75 1.25 2.75 2.75-1.25 2.75-2.75 2.75zm0-5c-1.25 0-2.25 1-2.25 2.25s1 2.25 2.25 2.25 2.25-1 2.25-2.25-1.05-2.25-2.25-2.25zM8.85 16.05c-1.5 0-2.75-1.25-2.75-2.75s1.25-2.75 2.75-2.75 2.75 1.25 2.75 2.75-1.2 2.75-2.75 2.75zm0-5c-1.25 0-2.25 1-2.25 2.25s1 2.25 2.25 2.25 2.25-1 2.25-2.25-1-2.25-2.25-2.25z",
    fill: "#10B1D7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "body-type-utilitarios_svg__clip0_5_285"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h50v20H0z"
  })))));
}
export default SvgBodyTypeUtilitarios;